/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {
    ISymbolNewStateTransitionConfig,
    ISymbolOldStateTransitionConfig,
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {BarbarianFuryGameAssets} from "../BarbarianFuryGameAssets";
import {BarbarianFuryGameConfig} from "../BarbarianFuryGameConfig";

export interface IBarbarianFurySymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    idle:ISymbolStateConfig;
    initialWin:ISymbolStateConfig;
}

export class BarbarianFuryReelSymbol extends StateReelSymbol {
    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    public changeState(newStateConfig:ISymbolNewStateTransitionConfig, oldStateConfig?:ISymbolOldStateTransitionConfig, skipEnergy:boolean = false, winDelay:number = 0):Timeline | null {
        if(BarbarianFuryGameConfig.instance.SYMBOLS_ALL.indexOf(this.symName) > -1 && this._currentState && this._currentState.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.initialWin.keyword) {
            const symSprite:PIXI.Sprite = new PIXI.Sprite(BarbarianFuryGameAssets.getSymbolStateTextures(this.symName)[0]);
            symSprite.anchor.set(0.5, 0.5);
            this.addChild(symSprite);
        }

        return super.changeState(newStateConfig, oldStateConfig);
    }


    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        const symName:string = this.symName.split("*")[0];

        if((newState.state.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.idle.keyword && BarbarianFuryGameConfig.instance.SYMBOLS_WITH_IDLE_SPINE.indexOf(symName) !== -1) ||
            (newState.state.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.initialWin.keyword && BarbarianFuryGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symName) !== -1)) {

            timeline.add(new SpineTween((stateAnimation as any), 0, symName + "_" + newState.state.keyword, 0), delay);
            if(newState.state.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.initialWin.keyword) {
                timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha : 1}), delay);

            } else {
                stateAnimation.alpha = 1;
            }
            if(newState.state.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.initialWin.keyword) {
                EventHandler.dispatchEvent(new GameEvent("removeFrozenAnimations"));
            }
            return;
        }

        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            if(this.currentState && this.currentState.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.initialWin.keyword) {
                this.changeState({
                    state : BarbarianFuryGameConfig.instance.SYMBOL_STATES.normal,
                    fadeInDuration : 0
                })
            }
        }

        if(newState.state.keyword === BarbarianFuryGameConfig.instance.SYMBOL_STATES.win.keyword) {
            const winTl:TimelineLite = new TimelineLite();
            winTl.add(new TweenLite(this.scale, 0.2, {x : 1, y : 1}));
            winTl.add(() => new TweenLite(this.scale, 0.2, {x : 1, y : 1, delay : 0.3}));
            timeline.add(winTl, delay);
            return;
        }
    }
}